import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const ReserveDetail = (props: any) => {
  return (
    <Stack spacing='15px' height={'auto'} p={'15px'}>
      <Typography fontWeight={700} color={'#484848'}>
        予約詳細
      </Typography>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>患者ID</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.reservationDetail &&
            props.reservationDetail.patient.patientno) ||
            '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>名前</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.reservationDetail &&
            props.reservationDetail.patient.fullname) ||
            '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>生年月日</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.reservationDetail && props.reservationDetail.patient.dob) ||
            '-'}
          {(props.reservationDetail &&
            `(${props.reservationDetail.patient.age})`) ||
            ''}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>予約日</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.reservationDetail &&
            props.reservationDetail.reserve.thedate) ||
            '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>時間</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.reservationDetail &&
            `${props.reservationDetail.reserve.starttime} - ${props.reservationDetail.reserve.finishtime}`) ||
            '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>来院時間</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.reservationDetail &&
            props.reservationDetail.reserve.visittime) ||
            '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>医師</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.reservationDetail &&
            props.reservationDetail.reserve.doctor) ||
            '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>予約タイプ</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.reservationDetail &&
            props.reservationDetail.reserve.reserve_type) ||
            '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>希望施術</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.reservationDetail &&
            props.reservationDetail.reserve.patient_note) ||
            '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>備考</Typography>
        <Typography fontWeight={500} color={'#484848'} whiteSpace={'pre-line'}>
          {(props.reservationDetail && props.reservationDetail.reserve.note) ||
            '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>ステータス</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.reservationDetail &&
            props.reservationDetail.reserve.statusname) ||
            '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>担当者</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.reservationDetail &&
            props.reservationDetail.reserve.fullname) ||
            '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>見積</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.reservationDetail &&
            props.reservationDetail.reserve.quoteid) ||
            '-'}
        </Typography>
      </Stack>
      <Stack mb={'10px'}>
        <Typography color={'#00000080'}>伝達事項</Typography>
        <Typography fontWeight={500} color={'#484848'}>
          {(props.reservationDetail &&
            props.reservationDetail.reserve.visitnote) ||
            '-'}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default ReserveDetail;
